<template>
  <a target="_blank" :href="url"><b>{{ name }}</b></a>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  name: "Link"
}
</script>